import React from "react";

export const Time = ({ color = "black", size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon"
      style={{ color }}
    >
      <g id="famicons:time-outline">
        <path
          id="Vector"
          d="M8.5 2C5.1875 2 2.5 4.6875 2.5 8C2.5 11.3125 5.1875 14 8.5 14C11.8125 14 14.5 11.3125 14.5 8C14.5 4.6875 11.8125 2 8.5 2Z"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_2"
          d="M8.5 4V8.5H11.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
